var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashAlt = function SvgTrashAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.063 19.5h1.124a.56.56 0 0 0 .563-.562V8.813a.56.56 0 0 0-.562-.563h-1.126a.56.56 0 0 0-.562.563v10.125a.56.56 0 0 0 .563.562M21.75 3.75h-3.863l-1.594-2.658A2.25 2.25 0 0 0 14.363 0H9.637a2.25 2.25 0 0 0-1.93 1.092L6.114 3.75H2.25a.75.75 0 0 0-.75.75v.75a.75.75 0 0 0 .75.75H3v15.75A2.25 2.25 0 0 0 5.25 24h13.5A2.25 2.25 0 0 0 21 21.75V6h.75a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.75M9.555 2.386a.28.28 0 0 1 .242-.136h4.406a.28.28 0 0 1 .242.136l.818 1.364H8.737zM18.75 21.75H5.25V6h13.5zM8.813 19.5h1.124a.56.56 0 0 0 .563-.562V8.813a.56.56 0 0 0-.562-.563H8.812a.563.563 0 0 0-.562.563v10.125a.56.56 0 0 0 .563.562"
  }))));
};
export default SvgTrashAlt;